angular.module('mtic.components.modules.generalModuleMap')
.service('itemFactory', function(
  GR78_ASSET_URL,
  EventManager,
  $log,
  $timeout,
  TIMING_CONSTANTS,
  language,
  DEV_VARIABLES,
  TeacherDataService,
  MapStateService,
  ModuleFilter
) {

    var currentActiveItem = null;

    var getIconFilename = function(item_info) {

      //assessments are easy
      if (item_info.resource_type === 'assessment') {
        if(item_info.config.assessment_type && item_info.config.assessment_type === 'formative'){
          if(item_info.complete && item_info.resourceState && item_info.resourceState.score_max >= 0.8){
            return 'formative_gold.png';
          }else if(item_info.complete){
            return 'formative_silver.png';
          }else if(!item_info.locked){
            return 'formative_unlocked.png';
          }else{
            return 'formative_locked.png';
          }
        }
        if(item_info.map_config && item_info.map_config.icon_options && (item_info.map_config.icon_options.summative_locked || item_info.map_config.icon_options.diagnostic_locked)){
          var status;
          if (item_info.config.assessment_type && item_info.config.assessment_type === 'summative' ){
            status = item_info.locked ? item_info.map_config.icon_options.summative_locked : item_info.map_config.icon_options.summative_unlocked
            status = item_info.complete ? item_info.map_config.icon_options.summative_complete : status;
            return status;
          }else{
            status = item_info.locked ? item_info.map_config.icon_options.diagnostic_locked : item_info.map_config.icon_options.diagnostic_unlocked
            status = item_info.complete ? item_info.map_config.icon_options.diagnostic_complete : status;
            return status;
          }
        }else{
          if (item_info.complete || item_info.config.assessment_type && item_info.config.assessment_type === 'summative' )
          {
            return 'assessment_complete.png';
          }
          return 'assessment.png';
        }
      }
      if (!item_info.display)
      {
        item_info.display = {};
      }


      //get the color from item_info.display.color, fall back to "red" if it isn't defined
      var color_string = (item_info.display.color !== undefined) ? item_info.display.color : 'red';

      var suffix;
      if (item_info.locked) {
        suffix = "_locked";
      } else {
        if (!item_info.resourceState || !item_info.resourceState.complete) {
          suffix = "_0"
        } else {

          var count = 0;

          if(item_info.map_config && item_info.map_config.item_scoring_breakdown){
            var max_scoring_found = 0;
            for(var scoring in item_info.map_config.item_scoring_breakdown){
              if(item_info.map_config.item_scoring_breakdown[scoring] && item_info.resourceState.score_max >= Number(scoring) && Number(scoring) > max_scoring_found ){
                count = item_info.map_config.item_scoring_breakdown[scoring];
                max_scoring_found = Number(scoring);
              }
            }
          }else{
            if (item_info.resourceState.score_max >= 1)
            {
              count = 3;
            } else if (item_info.resourceState.score_max >= 0.8)
            {
              count = 2;
            } else if (item_info.resourceState.score_max >= 0.5)
            {
              count = 1;
            }
          }
          if (color_string === 'blue') {
            count = 1//Math.min(count, 1);
          }
          count = Math.max(0, count);
          suffix = "_" + count;
          

        }
      }
      var filename = item_info.map_config && item_info.map_config.icon_options && item_info.map_config.icon_options.item_icon_name ? item_info.map_config.icon_options.item_icon_name + suffix + ".png" : "item_" + color_string + suffix + ".png";
      
      return filename;
    };
    return {
      unlockedByAgenda: false,
      getCurrentActiveItem: function() {
        return currentActiveItem;
      },
      createMapItem: function MapItem(item_info, eventManager, map_config) {     
        item_info.map_config =  map_config;   
        var scale = item_info.map_config && item_info.map_config.icon_options && item_info.map_config.icon_options.item_icon_scale ? item_info.map_config.icon_options.item_icon_scale : 1.0, alwaysHideTooltip = false || item_info.map_config && item_info.map_config.hide_tooltip;
        // Grab Relevant data for item

        this.id = item_info.id;
        this.name = item_info.name;
        this.slug = item_info.slug;
        this.type = item_info.resource_type;
        this.studentWork = item_info.studentWork;
        this.config = item_info.config;

        this.container = {};
        if (item_info.content)
        {
          this.container = item_info.content.container;
        }
        this.complete = item_info.complete;
        this.locked = (item_info.parent_resource_id > 2252 && item_info.parent_resource_id < 2258) ? false : item_info.locked//item_info.parent_resource_id === 1114 && window.location.href.indexOf('locxalhost') > -1 ? false :item_info.locked;//add this for unlocked m0: item_info.parent_resource_id === 1114 ? false :
        this.unlocked_by = item_info.unlocked_by;
        this.content = item_info.content;
        this.verletBody = null;
        this.parentItem = null;

        var agenda_highlight = null;

        if (DEV_VARIABLES.RESOURCES.MARK_COMPLETE.indexOf(this.slug ) > -1)
        {
          this.complete = true;
        }
        //Handle group stuff!!
        if (item_info.children && item_info.children.length > 0) {
          this.locked = true;
          var i = 0;
          for (i = 0; i < item_info.children.length; i++) {
            this.locked = this.locked && item_info.children[i].locked;
          }
          item_info.locked = this.locked;


          this.complete = true;
          for (i = 0; i < item_info.children.length; i++) {
            this.complete = this.complete && item_info.children[i].complete;
          }
          item_info.complete = this.complete;
          item_info.resourceState = {};
          item_info.resourceState.score_max = this.complete ? 1 : 0;
        }

        if(DEV_VARIABLES.RESOURCES.UNLOCK_THESE.indexOf(this.slug ) > -1) {
          this.locked = false;
        }
        if(DEV_VARIABLES.RESOURCES.LOCK_THESE.indexOf(this.slug ) > -1 || !ModuleFilter.checkAvailable(item_info)) {
          this.locked = true;
        }

        var sprite, icon;
        var startClickPos = {
          x: 0,
          y: 0
        };

        this.setDelegate = function(del) {
          var boundClick = (function(e) {
            del(this.slug);
          }).bind(this);
          sprite.on('pointertap', boundClick)
            //sprite.on('click', );
        }

        var getItemDisplayName = function() {
          var itemDisplayName;
          if (item_info.display && item_info.display.nameLangId) {
            itemDisplayName = language.get(item_info.display.nameLangId)
          } else {
            // if(item_info.slug.indexOf('gr78_m4') > -1 || item_info.slug.indexOf('g78_m4') > -1){
            //   itemDisplayName = language.get(item_info.slug+'_short', null, true)
            // }else{
            //   itemDisplayName = language.get(item_info.slug, null, true)
            // }
            itemDisplayName = language.get(item_info.slug, null, true);
          }
          if ((!itemDisplayName || itemDisplayName === item_info.slug) && item_info.name) {
            itemDisplayName = item_info.name;
          }
          return itemDisplayName;
        }

        this.updateIcon = function() {
          var ASSET_URL = item_info.map_config && item_info.map_config.asset_url ? item_info.map_config.asset_url : GR78_ASSET_URL;  
          if (this.type === 'symlink') {
            icon.texture = PIXI.loader.resources[ASSET_URL + "symlink.png"].texture;
          } else if(PIXI.loader.resources[ASSET_URL + getIconFilename(item_info)]) {
            icon.texture = PIXI.loader.resources[ASSET_URL + getIconFilename(item_info)].texture;
          }else {
            $log.warn('texture not found for : ', ASSET_URL + getIconFilename(item_info))
          }
          if(this.display_text){
            this.display_text.visible = !item_info.locked;
          }
        }
        this.buildTooltip = function() {
          if (tooltip !== null && tooltip !== undefined) {
            sprite.removeChild(tooltip);
            tooltip.interactive = false;
          }
          tooltip = new PIXI.Sprite();

          var font_color = item_info.map_config && item_info.map_config.tooltip_options && item_info.map_config.tooltip_options.fontcolor ? item_info.map_config.tooltip_options.fontcolor : 0xFFFFFF
          var fill_color = item_info.map_config && item_info.map_config.tooltip_options && item_info.map_config.tooltip_options.color ? item_info.map_config.tooltip_options.item_fillcolor || item_info.map_config.tooltip_options.color : 0x3B5763
          font_color = item_info.display.tooltip_fontcolor || font_color
          fill_color = item_info.display.tooltip_fillcolor || fill_color
          // Text Information
          var textInfo = new PIXI.Text(getItemDisplayName(), {
            fontFamily: 'Arial',
            align: 'center',
            fontSize: 24,
            fill: font_color,
            dropShadow: true,
            dropShadowDistance: 1,
            dropShadowBlur: 0,
            wordWrap: true,
            wordWrapWidth: 200
          });

          var tooltip_graphics = new PIXI.Graphics();

          var drawTooltipContainer = function() {
            tooltip_graphics.clear();
            // Draw Text Bubble that wraps around the text
            tooltip_graphics.lineStyle(0);
            tooltip_graphics.beginFill(fill_color);
            tooltip_graphics.drawRoundedRect(textInfo.x - 20, textInfo.y - 10, textInfo.width + 40, textInfo.height + 20, 10);
            tooltip_graphics.endFill();

            // Draw Triangle pointing to planet
            tooltip_graphics.beginFill(fill_color);
            tooltip_graphics.moveTo(textInfo.x + (textInfo.width / 2) - 5, textInfo.y - 10);
            tooltip_graphics.lineTo(textInfo.x + (textInfo.width / 2), textInfo.y - 18);
            tooltip_graphics.lineTo(textInfo.x + (textInfo.width / 2) + 5, textInfo.y - 10);
            tooltip_graphics.lineTo(textInfo.x + (textInfo.width / 2) - 5, textInfo.y - 10);
            tooltip_graphics.endFill();

            tooltip_graphics.x = -tooltip_graphics.width / 2 + 20;
            var height_offset = 10;
            if(map_config && map_config.map_style === 'ocmt'){
              height_offset = that.type === 'assessment' ? 85 : 65;
            }
            tooltip_graphics.y = icon.height / 2 + height_offset;

          }

          drawTooltipContainer();

          tooltip.addChild(tooltip_graphics);
          tooltip_graphics.addChild(textInfo);
          sprite.addChild(tooltip);
          tooltip.interactiveChildren = false;
          tooltip.visible = (map_config && map_config.tooltip_options && map_config.tooltip_options.always_visible)  || (item_info.config.assessment_type && item_info.config.assessment_type === 'summative' && !item_info.config.show_summative) ? true : false;
          var tooltip_scale = (map_config && map_config.tooltip_scale) ? map_config.tooltip_scale : 1;
          tooltip.scale.set(tooltip_scale, tooltip_scale)

          eventManager.listen('language:change', function() {
            if (textInfo === undefined) {
              return;
            }
            textInfo.setText(getItemDisplayName());
            drawTooltipContainer();
          })

          eventManager.listen('module:change:meta', function(){
            that.hideAgendaHighlight();
          })        

          var updateItemInfoComplete = function(existsItem){
            var exists_score_max = item_info.resourceState ? item_info.resourceState.score_max : null;
            item_info.complete = existsItem.completed;
            item_info.resourceState = {complete:existsItem.completed};
            item_info.resourceState.score_max =  exists_score_max ? Math.max(exists_score_max, existsItem.score) : existsItem.score;
            item_info.score = item_info.resourceState.score_max;
          }

          eventManager.listen("teacherStudentWorkspace:studentFilter:change",function(e,eventData){
            var filteredList = eventData.list||[];
            var doneItemsList = [];
            if(filteredList  && filteredList.length>0){
              doneItemsList = _.filter(filteredList,function(item){
                return item.resource_id === item_info.id;
              });
            }

            if(doneItemsList.length > 0){ 
              var exists_info = {score: null, completed: false}
              _.each(doneItemsList, function(existsItem){
                exists_info.completed = exists_info.completed || existsItem.completed
                exists_info.score = exists_info.score ? Math.max(exists_info.score, existsItem.score) : existsItem.score;
              })
              updateItemInfoComplete(exists_info);
            }else{
              item_info.complete = false;
              item_info.resourceState = {complete:false, score_max: null};
              item_info.score = null;
            }
            var ASSET_URL = item_info.map_config && item_info.map_config.asset_url ? item_info.map_config.asset_url : GR78_ASSET_URL;  
            if (item_info.resource_type === 'symlink' &&  PIXI.loader.resources[ASSET_URL + "symlink.png"]) {
              icon.texture = PIXI.loader.resources[ASSET_URL + "symlink.png"].texture;
            }
            else if(PIXI.loader.resources[ASSET_URL + getIconFilename(item_info)]){
              icon.texture = PIXI.loader.resources[ASSET_URL + getIconFilename(item_info)].texture;
            }
          });
        }        

        eventManager.listen('set:options', function(e, args){
          item_info.options = args;
        })

        var unclickableTypes = ['symlink']
        this.onButtonClick = function() {

          if (unclickableTypes.indexOf(this.type) > -1) {
            return;
          }


          //Cancel click events if they dragged more than 100 pixels
          var curPos = sprite.toGlobal(new PIXI.Point(0, 0));
          if (Math.pow(startClickPos.x - curPos.x, 2) + Math.pow(startClickPos.y - curPos.y, 2) > 100 * 100) {
            return;
          }

          $log.debug('[[mapItemFactory]] clicking on', item_info, 'LOCK STATUS:::::::::::::', this.locked);
          if (DEV_VARIABLES.RESOURCES.LOCK_THESE.indexOf(item_info.slug) > -1) {
            if (!TeacherDataService.isTeacherModuleView){
              this.locked = false;
            }
            else{
              this.locked = true;
            }
          }
          if(!ModuleFilter.checkAvailable(item_info)){
            this.locked = true;
            item_info.locked = true;
            eventManager.broadcast('display-maintenance-message', item_info.slug);
          }

          $timeout(function() {
            sprite.scale.set(1*scale, 1*scale);
            eventManager.broadcast('module:stop:pan');
            eventManager.broadcast('module:select:resource', item_info);
          }, TIMING_CONSTANTS.INSTANT)
        };

        this.unlock = function(force) {
          if((item_info.config.assessment_type && !force) || DEV_VARIABLES.RESOURCES.LOCK_THESE.indexOf(item_info.slug ) > -1 || !ModuleFilter.checkAvailable(item_info)) {            
            return
          }
          item_info.locked = false;
          this.locked = false;
          this.updateIcon();
        };

        this.lock = function() {          
          if(this.unlockedByAgenda){
            return;
          }
          item_info.locked = true;
          this.locked = true;
          this.updateIcon();
        }

        this.getItemInfo = function() {
          return item_info;
        }


        this.setItemComplete = function() {
          this.updateIcon();
          if (this.studentWork) {
            this.studentWork.completions++;
          } else {
            this.studentWork = {
              completions: 1,
            };
          }
        }

        //For setting up verlet links to items inside a folder
        //items in minimized folders should verlet links to their parent
        this.getLinkedBody = function() {
          if (this.shouldBeOnMap()) {
            return this.verletBody;
          } else {
            return this.parentItem.getLinkedBody();
          }
        }

        //Map items inside mimized folder items get ignored
        this.shouldBeOnMap = function() {
          if (this.parentItem !== null) {
            return this.parentItem.isExpanded;
          } else {
            return this.isExpanded === true ? false : true;
          }
        }

        this.showHighlight = function() {
          if (this.type === 'symlink') {
            return;
          }
          if (tooltip && !alwaysHideTooltip) {
            tooltip.visible = true;
          }
          sprite.scale.set(1.1*scale, 1.1*scale);
          if (sprite.parent !== null) {
            sprite.parent.setChildIndex(sprite, sprite.parent.children.length - 1);
          }
        }

      this.undoAgendaHighlight = function() {}


      this.selection_graphic=null;
      this.highlight_graphic=null;
      this.agenda_box_graphic=null;
      this.semi_ring = null;
      this.line_graphic = null;
      var that = this;
      var is_item_selected;
      this.addSemiRing = function(){   
        //var scale_size =  this.type === 'assessment' ? 1.25 : 1.025;
        var ASSET_URL = item_info.map_config && item_info.map_config.asset_url ? item_info.map_config.asset_url : GR78_ASSET_URL;  
        var ring_name = 'selection.png';
        if(item_info.map_config && item_info.map_config.map_style === 'ocmt' && item_info.map_config.icon_options && this.type === 'assessment'){
          ring_name = item_info.map_config.icon_options.selection_assessment;
        }
        this.semi_ring = new PIXI.Sprite(PIXI.loader.resources[ASSET_URL + ring_name].texture);
        this.semi_ring.anchor.set(0.5,0.5);
        this.semi_ring.scale.set(1.025, 1.025);
        this.semi_ring.interactive = false;
        this.semi_ring.hitArea = new PIXI.Rectangle(0,0,0,0);
        icon.addChild(this.semi_ring);     
        // this.semi_ring = new PIXI.Graphics();
        // var color = item_info.display.tooltip_fillcolor || map_config.tooltip_options.color;
        // this.semi_ring.lineStyle(3, color, 1)
        // if(this.type === 'assessment'){
        //   x_1 = 0.5; x_2 = -1; x_3 = 45;
        // }
        // this.semi_ring.arc(x_1, x_2, x_3, x_4, x_5)
        // //this.semi_ring.bezierCurveTo(-5-icon.width/2, 5-icon.height/2, 5-icon.width/2, 15-icon.height/2, 5+icon.width/2, 0)
        // this.semi_ring.interactive = false;
        // icon.addChildAt(this.semi_ring, 0);
      }
      this.rotateRing = function(){
        this.semi_ring.rotation = (this.semi_ring.rotation-0.015)%(Math.PI*2);
      }
      this.endRotation = function(){
        this.semi_ring.rotation = 0;
      }
      this.addBottomLineGraphics = function(){
        this.line_graphic = new PIXI.Graphics();
        var color = item_info.display.tooltip_fillcolor || map_config.tooltip_options.color;
        this.line_graphic.lineStyle(3, color, 1);        
        this.line_graphic.beginFill(color);
        var height = icon.height/2+5;
        var line_height = this.type === 'assessment' ? 50 : 30
        this.line_graphic.moveTo(0, height);
        this.line_graphic.lineTo(0, height+line_height)
        this.line_graphic.drawCircle(0, height+line_height, 7);
        this.line_graphic.interactive = false;
        icon.addChildAt(this.line_graphic, 0);
      }
      this.showAgendaHighlight = function(force, is_selection) {
        // $log.log('HIGHGLIGHT SELECTION : ' , item_info.display.position)
        if(item_info.map_config && item_info.map_config.selector_options &&  item_info.map_config.selector_options.disabled){
          return;
        }
        var ASSET_URL = item_info.map_config && item_info.map_config.asset_url ? item_info.map_config.asset_url : GR78_ASSET_URL;
        if(this.highlight_graphic===null && is_selection && (!item_info.map_config.selector_options || !item_info.map_config.selector_options.disable_highlight)){
          // this is used in the agenda editor view
          // $log.log('show agenda highlight', this.slug, is_selection)
          if(item_info.map_config.selector_options && item_info.map_config.selector_options.highlight_icon){
            icon.texture = PIXI.loader.resources[ASSET_URL + item_info.map_config.selector_options.highlight_icon + '.png'].texture;
            this.showing_highlight = true;
          }else{            
            var radius =  this.type === 'assessment' && (!item_info.config.assessment_type || item_info.config.assessment_type !== 'formative') ? 85 : 50;
            this.highlight_graphic = new PIXI.Graphics();
            this.highlight_graphic.lineStyle(22, 0x33CCFF,1)
            this.highlight_graphic.drawCircle(0, 0, radius)
            this.highlight_graphic.interactive = false;
            this.highlight_graphic.scale.set(0.75*scale,0.75*scale);
            this.highlight_graphic.hitArea = new PIXI.Rectangle(0,0,0,0);
            icon.addChildAt(this.highlight_graphic, 0);
          }          
        }else if (!is_selection && this.selection_graphic === null && (force !== false)){
          // this is used in the activity log view
          is_item_selected = is_selection;
          var scale_size =  this.type === 'assessment' ? 2.5 : 0.75;
          var selector_scale = item_info.map_config.selector_options && item_info.map_config.selector_options.selector_scale ? item_info.map_config.selector_options.selector_scale : scale_size;
          var selector_icon_name = item_info.map_config.selector_options && item_info.map_config.selector_options.icon_name ? item_info.map_config.selector_options.icon_name : "selection.png";

          if(item_info.map_config && item_info.map_config.selector_options && item_info.map_config.selector_options.drawn_selector){
            this.selection_graphic = new PIXI.Graphics();
            this.selection_graphic.lineStyle(18, 0xFFCC00,1);
            this.selection_graphic.drawCircle(0, 0, 48);
          }else{
            this.selection_graphic = new PIXI.Sprite(PIXI.loader.resources[ASSET_URL + selector_icon_name].texture);
            var anchor = item_info.map_config.selector_options && item_info.map_config.selector_options.anchor ? item_info.map_config.selector_options.anchor : {x: 0.5, y: 0.5};
            this.selection_graphic.anchor.set(anchor.x, anchor.y);
            this.selection_graphic.scale.set(selector_scale*scale,selector_scale*scale);
            this.selection_graphic.interactive = false;
            this.selection_graphic.hitArea = new PIXI.Rectangle(0,0,0,0);
          }        
          sprite.addChildAt(this.selection_graphic, 0); 
        }else if(!force){
          // $log.log('from toggle agenda selection', this.slug, is_selection)
          that.hideAgendaHighlight();
        }
      }
      this.hideAgendaHighlight = function(from_item_highlight) {
        if(item_info.map_config && item_info.map_config.selector_options &&  item_info.map_config.selector_options.disabled){
          return;
        }
        if(from_item_highlight && (this.highlight_graphic !== null || this.showing_highlight)){
          if(item_info.map_config.selector_options && item_info.map_config.selector_options.highlight_icon){
            var ASSET_URL = item_info.map_config && item_info.map_config.asset_url ? item_info.map_config.asset_url : GR78_ASSET_URL;
            icon.texture = PIXI.loader.resources[ASSET_URL + getIconFilename(item_info)].texture;
            this.showing_highlight = false;
          }else{
            icon.removeChild(this.highlight_graphic);
            this.highlight_graphic = null;
          }
        }if (!from_item_highlight && this.selection_graphic !== null){
          sprite.removeChild(this.selection_graphic);
          this.selection_graphic = null;
        }
      }

      this.hideHighlight = function() {
        if (tooltip && !alwaysHideTooltip) {
          tooltip.visible = (map_config && map_config.tooltip_options && map_config.tooltip_options.always_visible) || (item_info.config.assessment_type && item_info.config.assessment_type === 'summative' && !item_info.config.show_summative)  ? true : false;
        }
        sprite.scale.set(1*scale, 1*scale);
      }

      this.setScale = function(scaleToBeSet){
        scale = scaleToBeSet;
        sprite.scale.set(scale,scale);
      }

      this.alwaysHideTooltip = function(){
        alwaysHideTooltip = true;
        tooltip.visible = false;
      }

        this.pointerdown = function() {
            sprite.scale.set(0.9*scale, 0.9*scale);
            startClickPos = sprite.toGlobal(new PIXI.Point(0, 0));
          }
          /**
           * Tooltip setup
           */
        var tooltip;

        icon = new PIXI.Sprite();
        if(item_info.map_config && item_info.map_config.icon_options && item_info.map_config.icon_options.icon_anchor){          
          icon.anchor.set(item_info.map_config.icon_options.icon_anchor.x, item_info.map_config.icon_options.icon_anchor.y);
        }else{
          icon.anchor.set(0.5, 0.5);
        }
        sprite = new PIXI.Sprite();
        this.sprite = sprite;
        sprite.scale.set(1*scale, 1*scale);

        var mouseOver = this.showHighlight.bind(this);
        sprite.on('mouseover', function() {
          mouseOver();
        });

        var mouseOut = this.hideHighlight.bind(this);
        sprite.on('pointerout', function() {
          mouseOut();
        });

        var pointerdown = this.pointerdown.bind(this);
        sprite.on('pointerdown', function() {
          pointerdown();
        });

        if (item_info.resource_type !== "group") {
          var boundClick = this.onButtonClick.bind(this);
          sprite.on('pointertap', boundClick);
        } else if (item_info.resource_type !== 'symlink') {
          this.open = false;
        }

        this.updateIcon();
        if (this.type === "group") {
          var bg = new PIXI.Sprite(icon.texture);
          bg.width += 20;
          bg.height += 20;

          bg.anchor.set(0.5, 0.5);
          sprite.addChild(bg);
        }
        sprite.addChild(icon);

        if(item_info.config.display_text){
          this.display_text = new PIXI.Text(item_info.config.display_text.text, item_info.config.display_text.options);
          sprite.addChild(this.display_text);
          this.display_text.position = item_info.config.display_text.position || {x: sprite.width/2-this.display_text.width/2, y:sprite.height/2-this.display_text.height/2};
          this.display_text.visible = !item_info.locked;
        }


        if (item_info.display.position !== undefined) {
          var divideBy = item_info.slug.indexOf("_g78_m0_")>-1?1:5;
          var startPosx = item_info.map_config && item_info.map_config.position_x_offset ? item_info.map_config.position_x_offset : item_info.slug.indexOf("_g78_m0_")>-1?1300:0;
          var startPosY = item_info.map_config && item_info.map_config.position_y_offset ? item_info.map_config.position_y_offset : item_info.slug.indexOf("_g78_m0_")>-1?300:0;
          sprite.position.set(startPosx + item_info.display.position.x/divideBy, startPosY + item_info.display.position.y/divideBy);
        } else {
          sprite.position.set(0, 0);
        }
        sprite.interactive = true; //!item_info.locked;
        sprite.buttonMode = true;
        this.buildTooltip();
        //for testing...
        //this.unlock();

      }
    }
  });
